import React, { useEffect } from "react";
import { ReactComponent as SupplierIcon } from "../../../assets/icons/modal/supplier.svg";
import DefaultModal from "../DefaultModal/DefaultModal";
import AddTagsForm from "../forms/AddTagsForm/AddTagsForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddTagsModal: React.FC<Props> = (props) => {
  const onApply = () => {
    props.onApply();
    props.onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          onClose={props.onClose}
          title="Додати conditions"
          subTitle='Додайте новий conditions до системи. Заповніть необхідну інформацію та натисніть "Додати".'
        >
          <SupplierIcon />
        </ModalTitle>
        <AddTagsForm onApply={onApply} onClose={props.onClose} />
      </div>
    </DefaultModal>
  );
};

export default AddTagsModal;
